<template>
  <div>
    <div id="reviews"></div>
    <v-img src="/static/img/home/sadko/home1.jpg" class="reviews-img">
      <v-carousel class="text-xs-center">
        <v-carousel-item
          dark
          v-for="review in reviews"
          :key="review.id"
        >
          <div class="reviews-mask">
            <div class="reviews-box">
              <div class="reviews-offer">{{ review.h1 }}</div>
              <div class="reviews-sub-offer">{{ review.review }}</div>
              <div class="reviews-name">{{ review.name }}</div>
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-img>
  </div>
</template>

<script>
export default {
  data () {
    return {
      reviews: [
        {
          id: 1,
          h1: 'Отзывы',
          review: '"Бассейн тёплый, большой. Можно как семейный отдых организовать."',
          name: 'Анатолий'
        },
        {
          id: 2,
          h1: 'Отзывы',
          review: '"Очень хорошая сауна, были с детьми они в восторге им очень понравился бассейн вода тёплая."',
          name: 'Елена'
        },
        {
          id: 3,
          h1: 'Отзывы',
          review: '"Большой и чистый бассейн.Чисто и комфортно"',
          name: 'Татьяна'
        },
        {
          id: 4,
          h1: 'Отзывы',
          review: '"Отличный чистейший бассейн (около 160-170 глубиной). Желоб, закрытый решеткой по периметру бассейна (для стока воды) вычищен до блеска. В помещениях чисто, хорошая вентиляция. Замечательная сауна."',
          name: 'Влад'
        },
        {
          id: 5,
          h1: 'Отзывы',
          review: '"Очень Адекватная сауна,погулять можно на ура,и ценник для таких условий довольно таки хороший!!!!!всем советую."',
          name: 'Александр'
        }
      ]
    }
  }
}
</script>

<style scoped>
#reviews {
  position: relative;
  top: -90px;
}

.reviews-img {
  height: 500px;
}

.reviews-mask {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

.reviews-box {
  width: 70%;
  margin: 0px auto;
}

.reviews-offer {
  font-size: 36px;
  font-weight: 900;
  margin-top: 15vh;
  margin-bottom: 40px;
  color: white;
}

.reviews-sub-offer {
  font-size: 19px;
  margin: 40px 0px;
  color: white;
}

.reviews-name {
  font-size: 23px;
  font-weight: 900;
  margin: 40px 0px;
  color: white;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .reviews-offer {
    font-size: 24px;
    margin-top: 15vh;
  }

  .reviews-sub-offer {
    font-size: 16px;
  }

  .reviews-name {
    font-size: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/screens/sadko/Reviews.vue